'use strict';

import './leadForm.scss';
import 'lead-form/client/index.css';
import 'lead-form/client/chat/index.css';
import LeadForm from 'lead-form/client';

const controller = function(){};

export default (
    $rootScope,
    $compile,
    listingService,
    leadFormModelService,
    employeeReviewsModalService,
    userDataService,
    leadFormService,
    sellerService,
    dataBrokerService,
    dealerChatService,
    viewport
) => {
    return {
        controller,
        controllerAs: '$ctrl',
        transclude: true,
        bindToController: true,
        restrict: "E",
        scope: {
            position: '@',
            apigeeHost: '@',
            vdpApiKey: '@',
            showSpcAlternate: "<",
            isDealerInspire: '@'
        },
        link: function(scope, el, attrs, ctrl, transclude) {
            transclude(function(transEl, transScope) {
                el.append(transEl);
                transScope.$ctrl = scope.$ctrl;
            });

            function getSeller() {
                return sellerService.getSeller().then(function (raw) {
                    return raw.data.sellerDto;
                }, function(e) {
                    // eslint-disable-next-line no-console
                    /* istanbul ignore next */
                    console.log(e);
                    /* istanbul ignore next */
                    return {};
                });
            }

            function checkIfOnline(listing) {
                let listingDetail = listing.listingDetailDto;
                if (listingDetail.dealerChatProvider === 'Contact at Once'){
                    return dealerChatService.isDealerOnline(listing.listingDetailDto.customerId).then( isOnline => {
                        listing.listingDetailDto.isOnline = isOnline;
                        return Promise.resolve(listing);
                    });
                } else {
                    return Promise.resolve(listing);
                }
            }

            function getGoogleAnalyticsId () {
                if (window.ga) {
                    let gaId;
                    // cars only loads one tracker
                    window.ga.getAll().forEach((tracker) => {
                        gaId = tracker.get('clientId');
                    });
                    return gaId;
                }
            }

            listingService.getListing().then( listing => {
                checkIfOnline(listing).then( listing => {
                    return Promise.all([
                        Promise.resolve(listing),
                        getSeller(),
                        dataBrokerService.getItem('employees')
                    ]);

                })
                .then((data) => {
                    let listing, seller, employees, listingInfo, hasPageStateLeadBeenFired = false, hasEmployees = false;

                    listing = data[0].listingDetailDto;
                    seller = data[1];
                    employees = data[2];

                    const visitorCookie = leadFormService.getCarsVisitorCookie();
                    const pdid = visitorCookie.pdid;


                    if (employees && employees.length > 0){
                        employees = employeeReviewsModalService.populateCarousel(employees);
                        hasEmployees = true;
                    }

                    const formData = leadFormModelService.getModel(listing);

                    listingInfo = {
                        customerId: listing.customerId,
                        vin: listing.vin,
                        stockNumber: listing.stockNumber,
                        price: listing.price,
                        dealerName: listing.dealerName,
                        trimName: listing.trimName,
                        makeName: listing.makeName,
                        modelName: listing.modelName,
                        modelYear: listing.modelYear,
                        stockType: listing.stockTypeCode,
                        listingId: listing.listingId,
                        sellerId: listing.sellerId,
                        privatePartyListing: listing.privatePartyListing,
                        dipk: listing.dipk,
                        dealerChatProvider: listing.dealerChatProvider,
                        locationId: listing.locationId,
                        defaultToChatTab: leadFormService.getDefaultToChatTab(),
                    };

                    /* istanbul ignore next */
                    if (seller) {
                        listingInfo.hasSellAndTrade = seller.hasSellAndTrade;
                        listingInfo.hasSecureCreditApp = seller.hasSecureCreditApp;
                    }

                    const searchAlertsConfig = leadFormService.getSearchAlertsConfig();

                    const leadForm = new LeadForm(el[0], {
                        hasEmployees,
                        pdid,
                        embeddedChatDealerLogo: listing.dealerLogoImageLocation,
                        dealerLocationId: listing.locationId,
                        embeddedChatApi: listing.embeddedChatApi,
                        showLeadFormChat: listing.isDealerInspire || listing.isOnline,
                        zipCode: listing.zipcode,
                        searchAlertsUrl: searchAlertsConfig.url,
                        searchAlertsName: searchAlertsConfig.name,
                        onPrelead(values) {
                            /* istanbul ignore next */
                            const employeeIndex = employeeReviewsModalService.getSelected();
                            /* istanbul ignore next */
                            const carsUserData = JSON.parse(localStorage.getItem('Cars.userData')) || {};
                            /* istanbul ignore next */
                            let prevFormData = JSON.parse(localStorage.getItem('Cars.emailFormData'));

                            let carsVisitor;
                            /* istanbul ignore next */
                            try {
                                /* istanbul ignore next */
                                carsVisitor = JSON.parse(carsUserData.carsVisitor) || {};
                            } catch (e) {
                                /* istanbul ignore next */
                                carsVisitor = {};
                            }

                            /* istanbul ignore next */
                            if (!employeeIndex || employeeIndex >= employees.length) {
                                /* istanbul ignore next */
                                leadForm.options.leadServiceUrl = `${ctrl.apigeeHost}/lead-qualification-service/1.0/inventoryLead?apikey=${ctrl.vdpApiKey}`;
                            } else {
                                /* istanbul ignore next */
                                const selectedEmployee = employees[employeeIndex];
                                /* istanbul ignore next */
                                leadForm.options.leadServiceUrl = `${ctrl.apigeeHost}/lead-qualification-service/1.0/inventoryConnectionLead?apikey=${ctrl.vdpApiKey}`;
                                /* istanbul ignore next */
                                values.drContactId = selectedEmployee.id;
                                /* istanbul ignore next */
                                values.drDealerId = selectedEmployee.drDealerId;
                                /* istanbul ignore next */
                                values.drEmployeeName = `${selectedEmployee.firstName} ${selectedEmployee.lastName}`;
                                /* istanbul ignore next */
                                values.drContactType = '2';
                                /* istanbul ignore next */
                                values.drEmployeeIndex = employeeIndex;
                                /* istanbul ignore next */
                                values.comments = `This customer would like to work with ${values.drEmployeeName}. ` + values.comments;
                            }

                            /* istanbul ignore next */
                            values.pdid = carsVisitor.pdid || '';
                            /* istanbul ignore next */
                            values.gaid = getGoogleAnalyticsId() || '';
                            /* istanbul ignore next */
                            values.pcid = carsVisitor.pcid || '';
                            /* istanbul ignore next */
                            values.aff = userDataService.getValue('affiliate') || 'national';
                            /* istanbul ignore next */
                            values.zipCode = carsUserData.zip || (listing.zipcode ? listing.zipcode : '60606');
                            /* istanbul ignore next */
                            values.phonetype = 'day';
                            /* istanbul ignore next */
                            values.dayPhone = prevFormData ? prevFormData.phone : '';
                            /* istanbul ignore next */
                            localStorage.setItem('Cars.emailFormData', JSON.stringify(values));
                            /* istanbul ignore next */
                            return values;
                        },
                        onSuccess(leadFormResponse, chatAlsSubmit = false) {
                            /* istanbul ignore next */
                            let hasEmployees = leadFormResponse.drContactId ? true : false;
                            /* istanbul ignore next */
                            leadFormService.submitLead(leadFormResponse, listing, hasEmployees, chatAlsSubmit);
                        },
                        onError(errors) {
                            /* istanbul ignore next */
                            leadFormService.errorCallback(errors);
                        }
                    });

                    /* istanbul ignore next */
                    leadForm.on("embedded-chat-send", () => {
                        leadFormService.submitLead(listingInfo, listing, {}, true);
                        if (!hasPageStateLeadBeenFired) {
                            dealerChatService.fireChatPageStateEvent();
                            hasPageStateLeadBeenFired = true;
                        }
                    });

                    leadForm.on("email-tab-clicked", (e) => {
                        leadFormService.emailTabClickStateUpdate();
                    });

                    leadForm.on("chat-tab-clicked", (e) => {
                        leadFormService.chatTabClickStateUpdate();
                    });

                    leadFormService.modalCloseStateUpdate();

                    /* istanbul ignore next */
                    leadForm.prePopulate(formData);
                    /* istanbul ignore next */
                    leadForm.setLeadInformation(listingInfo);

                    /* instanbul ignore next*/
                    // Reset Tab Default
                    leadFormService.setDefaultToChatTab(false);

                    leadForm.on('email-changed', function(e) {
                        const emailVal = leadForm.elEmailAddress.value;
                        if (emailVal) {
                            const detail = {email: emailVal};
                            localStorage.setItem('cars.localStorage.signalFormTrackingData', JSON.stringify(detail));
                            window.document.body.dispatchEvent(new CustomEvent('emailEntered', detail));
                        }
                    });

                    /* istanbul ignore next */
                    if (employees && employees.length) {
                        /* istanbul ignore next */
                        const isMobile = viewport.isMobile() || viewport.isTablet();
                        /* istanbul ignore next */
                        const employeeClass = 'employee-carousel';
                        /* istanbul ignore next */
                        const employeeAttributes = $rootScope.$new();

                        /* istanbul ignore next */
                        employeeAttributes.isInModal = `${ctrl.position}`;
                        /* istanbul ignore next */
                        employeeAttributes.location = isMobile ? "mobile-on-page" : false;

                        const showViewAll = `${ctrl.position}` === 'desktop' ? true : false;
                        /* istanbul ignore next */
                        const employeeLeadForm = $compile(
                            `${'<employee-carousel ' +
                            `class=${employeeClass} ` +
                            'is-in-modal="{{::isInModal}}" ' +
                            'location="{{::location}}" ' +
                            'setTo="9" ' +
                            'half-face="true"' +
                            `show-view-all=${showViewAll}` +
                            '></employee-carousel>'}`
                        )(employeeAttributes);
                        leadForm.injectEmployeeLeadForm(employeeLeadForm[0]);
                    }

                });

            });
        }
    };
};
